import { render, staticRenderFns } from "./newI18n.vue?vue&type=template&id=ae39a216"
import script from "./newI18n.vue?vue&type=script&lang=js"
export * from "./newI18n.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports